import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3f3ae48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReturnSlip" }
const _hoisted_2 = { class: "ReturnSlip_Top" }
const _hoisted_3 = { class: "ReturnSlip_TopWrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ReturnSlip_TopWrapper_Title" }, "返品伝票照会(明細)", -1))
const _hoisted_5 = { class: "ReturnSlip_TopWrapper_Container" }
const _hoisted_6 = { class: "ReturnSlip_TopWrapper_Content" }
const _hoisted_7 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_8 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "返品受領日", -1))
const _hoisted_10 = { class: "ReturnSlip_ListContent" }
const _hoisted_11 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "取次返品日", -1))
const _hoisted_13 = { class: "ReturnSlip_ListContent" }
const _hoisted_14 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_15 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "取次伝票NO", -1))
const _hoisted_17 = { class: "ReturnSlip_ListContent" }
const _hoisted_18 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "イベントNO", -1))
const _hoisted_20 = { class: "ReturnSlip_ListContent" }
const _hoisted_21 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_22 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "イベント名", -1))
const _hoisted_24 = { class: "ReturnSlip_ListContent" }
const _hoisted_25 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "版元コード", -1))
const _hoisted_27 = { class: "ReturnSlip_ListContent" }
const _hoisted_28 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_29 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "取次協会コード", -1))
const _hoisted_31 = { class: "ReturnSlip_ListContent" }
const _hoisted_32 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "取次コード", -1))
const _hoisted_34 = { class: "ReturnSlip_ListContent" }
const _hoisted_35 = { class: "ReturnSlip_TopWrapper_Content" }
const _hoisted_36 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_37 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "取次名", -1))
const _hoisted_39 = { class: "ReturnSlip_ListContent" }
const _hoisted_40 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "搬入先コード", -1))
const _hoisted_42 = { class: "ReturnSlip_ListContent" }
const _hoisted_43 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_44 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "搬入先名", -1))
const _hoisted_46 = { class: "ReturnSlip_ListContent" }
const _hoisted_47 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "正味金額合計", -1))
const _hoisted_49 = { class: "ReturnSlip_ListContent" }
const _hoisted_50 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_51 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "GROW伝票NO", -1))
const _hoisted_53 = { class: "ReturnSlip_ListContent" }
const _hoisted_54 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "本体価格合計", -1))
const _hoisted_56 = { class: "ReturnSlip_ListContent" }
const _hoisted_57 = { class: "ReturnSlip_TopWrapper_List" }
const _hoisted_58 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "自己伝票NO", -1))
const _hoisted_60 = { class: "ReturnSlip_ListContent" }
const _hoisted_61 = { class: "ReturnSlip_TopWrapper_ListItem" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ReturnSlip_ListTitle" }, "倉庫コード", -1))
const _hoisted_63 = { class: "ReturnSlip_ListContent" }
const _hoisted_64 = { class: "ReturnSlip_TableContainer" }
const _hoisted_65 = { class: "ReturnSlip_Table" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "自己伝票行NO"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, [
      /*#__PURE__*/_createTextVNode("書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Medium th_sort" }, [
      /*#__PURE__*/_createTextVNode("出版社"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("書誌コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Normal th_sort" }, "ISBN"),
    /*#__PURE__*/_createElementVNode("th", { class: "TH_Large th_sort" }, "伝票書名"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "返品数"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "掛率"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "正味金額"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "商品区分コード"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, "商品区分名"),
    /*#__PURE__*/_createElementVNode("th", { class: "th_sort" }, [
      /*#__PURE__*/_createTextVNode("雑誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ])
  ])
], -1))
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 0,
  class: "ResultMessageNull"
}

import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import axios from "axios";
import { ReturnSlip } from "./ReturnSlip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnSlipDetail',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;
const route = useRoute();

const emit = __emit;
emit("toggleGlobalHeader");

// テーブル表示項目----------------------------------------------
let search_result = ref<ReturnSlip[]>([
  {
    acceptedHenpinDate: "",
    toritugiHenpinDate: "",
    toritugiDenpyouNumber: "",
    eventNumber: -1,
    eventMei: "",
    hanmotoCd: "",
    toritugiKyoukaiCd: "",
    toritugiCd: "",
    toritugiMei: "",
    hannyusakiCd: "",
    hannyusakiMei: "",
    syoumiTotalPrice: -1,
    growDenpyouNumber: "",
    hontaiTotalPrice: -1,
    jikoDenpyouNumber: "",
    jikoDenpyouRowNumber: -1,
    syosiCd: "",
    syuppanSyosiCd: "",
    isbn: "",
    title: "",
    hontaiPrice: -1,
    henpinSuu: -1,
    kakeritu: -1,
    syoumiPrice: -1,
    syouhinKbnCd: "",
    syouhinKbnMei: "",
    soukoCd: -1,
    zassiCd: "",
    syubetuKbn: -1,
    syubetu: "",
  },
]);

// データ取得関連---------------------------------------------
const getReturnSlipData = async (): Promise<void> => {
  console.log(route.params.id);

  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/denpyou/henpin/getDetails?jikoDenpyouNumber=${route.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    search_result.value.splice(0);
    res.data.forEach((henpin: ReturnSlip) => {
      search_result.value.push(henpin);
    });
    console.log(search_result.value[0]);
  } catch (error) {
    console.log(error);
    alert("データの取得に失敗しました");
  }
};
getReturnSlipData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(search_result)[0].acceptedHenpinDate), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(search_result)[0].toritugiHenpinDate), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(search_result)[0].toritugiDenpyouNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(search_result)[0].eventNumber), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(search_result)[0].eventMei), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(search_result)[0].hanmotoCd), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(search_result)[0].toritugiKyoukaiCd), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(search_result)[0].toritugiCd), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(search_result)[0].toritugiMei), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(search_result)[0].hannyusakiCd), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(search_result)[0].hannyusakiMei), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(search_result)[0].syoumiTotalPrice), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(search_result)[0].growDenpyouNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(search_result)[0].hontaiTotalPrice), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(search_result)[0].jikoDenpyouNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(search_result)[0].soukoCd), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createElementVNode("table", _hoisted_65, [
        _hoisted_66,
        (_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_67, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(result.jikoDenpyouRowNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syosiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syuppanSyosiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.isbn), 1),
                  _createElementVNode("td", null, _toDisplayString(result.title), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hontaiPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(result.henpinSuu), 1),
                  _createElementVNode("td", null, _toDisplayString(result.kakeritu), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syoumiPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syubetuKbn), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syubetu), 1),
                  _createElementVNode("td", null, _toDisplayString(result.zassiCd), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(search_result).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})